import {autoserializeAs} from "dcerialize";
import {ContactFormSender} from "./ContactFormSender";

export class ContactForm {
  @autoserializeAs(() => ContactFormSender)
  public readonly sender: ContactFormSender;
  @autoserializeAs(() => String)
  public subject: string;
  @autoserializeAs(() => String)
  public message: string;
  @autoserializeAs(() => String)
  public noBotVerification?: string;

  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  public constructor(sender: ContactFormSender, subject: string, message: string) {
    this.sender = sender;
    this.subject = subject;
    this.message = message;
  }

  public static createEmpty(subject?: string): ContactForm {
    return new ContactForm(new ContactFormSender("", ""), subject ?? "", "");
  }
}
